var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "groupbuy-list"
  }, [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GroupbuyingsList'
      }
    }
  }, [_vm._v("團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("團購列表")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-2 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("團購列表")]), _c('BIconQuestionCircle', {
    staticClass: "d-none d-md-block",
    attrs: {
      "id": "popover-tips"
    }
  }), _c('b-popover', {
    attrs: {
      "target": "popover-tips",
      "triggers": "hover focus click"
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('ul', [_c('li', [_vm._v("準備中：開團設定完成，待團購開始日即生效")]), _c('li', [_vm._v("開團中：於開團期限內進行中之團購")]), _c('li', [_vm._v("待取貨：團購時間已截止，待顧客完成取貨")]), _c('li', [_vm._v(" 已完成：已完成出貨、顧客已取貨或訂單取消且退款完成之團購 ")])])])]), _c('BIconQuestionCircle', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-tips",
      modifiers: {
        "modal-tips": true
      }
    }],
    staticClass: "d-md-none"
  }), _c('b-modal', {
    attrs: {
      "id": "modal-tips",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('ul', [_c('li', [_vm._v("準備中：開團設定完成，待團購開始日即生效")]), _c('li', [_vm._v("開團中：於開團期限內進行中之團購")]), _c('li', [_vm._v("待取貨：團購時間已截止，待顧客完成取貨")]), _c('li', [_vm._v(" 已完成：已完成出貨、顧客已取貨或訂單取消且退款完成之團購 ")])])])])], 1), _c('div', {
    staticClass: "col-6 d-flex justify-content-end"
  }, [_vm.checkPermission([_vm.consts.STORE_GROUPBUYING_CREATE]) ? _c('b-button', {
    staticClass: "mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("我要開團")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', {
    staticClass: "align-items-center mb-2 mb-xl-0"
  }, [_c('b-form-group', {
    staticClass: "flex-shrink-0 ml-1 ml-xl-2 mb-0",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var ariaDescribedby = _ref.ariaDescribedby;
        return [_c('b-form-checkbox-group', {
          attrs: {
            "id": "checkbox-group-1",
            "options": _vm.statusOptions,
            "aria-describedby": ariaDescribedby
          },
          on: {
            "change": function change($event) {
              return _vm.handleCheckedTypes();
            }
          },
          model: {
            value: _vm.selectedTypes,
            callback: function callback($$v) {
              _vm.selectedTypes = $$v;
            },
            expression: "selectedTypes"
          }
        })];
      }
    }])
  })], 1)])]), _c('div', {
    staticClass: "d-flex flex-wrap mb-3 justify-content-end"
  }, [_c('div', {
    staticClass: "row-searchbar d-flex mb-2 mb-md-0 mr-md-2"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "120px",
      "height": "45px"
    },
    attrs: {
      "options": _vm.searchOptions
    },
    model: {
      value: _vm.keyword_type,
      callback: function callback($$v) {
        _vm.keyword_type = $$v;
      },
      expression: "keyword_type"
    }
  }), _c('div', {
    staticClass: "w-100"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.placeholderMap[_vm.keyword_type]
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getGroupbuyList.apply(null, arguments);
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  })], 1)], 1), _c('DateSearchPicker', {
    staticClass: "mr-md-2 mr-0",
    attrs: {
      "disabledEndAtDates": _vm.disabledEndAtDates
    },
    on: {
      "update:disabledEndAtDates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "update:disabled-end-at-dates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      }
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }), _c('b-button', {
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v("匯出")])], 1), _c('b-tabs', {
    on: {
      "input": _vm.handleChangeTab
    },
    model: {
      value: _vm.currentTabIndex,
      callback: function callback($$v) {
        _vm.currentTabIndex = $$v;
      },
      expression: "currentTabIndex"
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('b-tab', {
      key: tab.status,
      attrs: {
        "title": tab.title
      }
    }, [_c('b-card-text', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('b-table', {
      attrs: {
        "striped": "",
        "hover": "",
        "responsive": "",
        "items": _vm.groupbuys,
        "fields": _vm.fields,
        "busy": _vm.isFetchGroupbuyList
      },
      scopedSlots: _vm._u([{
        key: "table-busy",
        fn: function fn() {
          return [_c('div', {
            staticClass: "text-center my-2"
          }, [_c('b-spinner', {
            staticClass: "align-middle"
          })], 1)];
        },
        proxy: true
      }, {
        key: "cell(groupbuying_number)",
        fn: function fn(data) {
          return [_c('router-link', {
            attrs: {
              "to": {
                name: 'GroupbuyingsDetail',
                params: {
                  groupbuyID: data.item.id
                }
              }
            }
          }, [_vm._v(_vm._s(data.item.groupbuying_number) + " ")])];
        }
      }, {
        key: "cell(title)",
        fn: function fn(data) {
          return [_c('div', [_vm._v(" " + _vm._s(data.item.products[0] && data.item.products[0].title) + " ")]), _c('div', {
            staticClass: "mb-1"
          }, [_vm._v(" " + _vm._s(data.item.products[0] && data.item.products[0].sale_page_code) + " ")])];
        }
      }, {
        key: "cell(picture)",
        fn: function fn(data) {
          return [data.item.products[0] && data.item.products[0].image_list[0] && data.item.products[0].image_list[0].pic_url ? _c('b-img-lazy', {
            staticClass: "thumb-image",
            attrs: {
              "src": data.item.products[0] && data.item.products[0].image_list[0] && data.item.products[0].image_list[0].pic_url,
              "alt": "商品圖片",
              "width": "50",
              "height": "50"
            }
          }) : _vm._e()];
        }
      }, {
        key: "cell(branch_name)",
        fn: function fn(data) {
          return [_c('div', [_vm._v(" " + _vm._s(data.item.group.branch.name) + " ")]), _c('div', {
            staticClass: "mt-1"
          }, [_vm._v(" " + _vm._s(data.item.group.branch.branch_code) + " ")])];
        }
      }, {
        key: "cell(group)",
        fn: function fn(data) {
          return [_c('div', {
            staticClass: "mb-1"
          }, [_vm._v(" " + _vm._s(data.item.group.name) + " ")]), _c('div', [_vm._v(" " + _vm._s(data.item.group.group_number) + " ")])];
        }
      }, {
        key: "cell(date)",
        fn: function fn(data) {
          return [_c('div', {
            staticClass: "mb-1"
          }, [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.start_at), "yyyy-MM-dd HH:mm")) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.end_at), "yyyy-MM-dd HH:mm")) + " ")])];
        }
      }, {
        key: "head(tracking_code)",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex"
          }, [_c('span', {
            staticClass: "d-flex cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.handleSort('tracking_code');
              }
            }
          }, [_vm._v(" 員編 "), _c('sort-caret', {
            staticClass: "ml-2",
            attrs: {
              "status": _vm.sortBy === 'tracking_code' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
            }
          })], 1)])];
        },
        proxy: true
      }, {
        key: "cell(tracking_code)",
        fn: function fn(data) {
          return [_c('div', [_vm._v(" " + _vm._s(data.item.main_id ? "總公司開團" : data.item.tracking_code) + " ")])];
        }
      }, {
        key: "head(groupbuying_product_order_quantity)",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex"
          }, [_c('span', {
            staticClass: "d-flex cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.handleSort('order_quantity');
              }
            }
          }, [_vm._v(" 本群銷量 "), _c('sort-caret', {
            staticClass: "ml-2",
            attrs: {
              "status": _vm.sortBy === 'order_quantity' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
            }
          })], 1)])];
        },
        proxy: true
      }, {
        key: "cell(groupbuying_product_order_quantity)",
        fn: function fn(data) {
          return [_vm._v(" " + _vm._s(data.item.groupbuying_product_order_quantity || 0) + " ")];
        }
      }, {
        key: "head(total_quantity)",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex"
          }, [_c('span', {
            staticClass: "d-flex cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.handleSort('quantity');
              }
            }
          }, [_vm._v(" 剩餘庫存 "), _c('sort-caret', {
            staticClass: "mx-1",
            attrs: {
              "status": _vm.sortBy === 'quantity' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
            }
          }), _vm._v(" /總數量 ")], 1)])];
        },
        proxy: true
      }, {
        key: "cell(total_quantity)",
        fn: function fn(data) {
          return [data.item.products[0] ? _c('div', [data.item.products[0].sku_list[0] ? _c('span', [_vm._v(" " + _vm._s(data.item.products[0].sku_list[0].quantity || 0) + " ")]) : _vm._e(), _vm._v(" / "), data.item.products[0].sku_list[0] ? _c('span', [_vm._v(" " + _vm._s((data.item.products[0].sku_list[0].quantity || 0) + (data.item.products[0].sku_list[0].sale_quantity || 0)) + " ")]) : _vm._e()]) : _vm._e()];
        }
      }, {
        key: "head(date)",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex"
          }, [_c('span', {
            staticClass: "d-flex cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.handleSort('start_at');
              }
            }
          }, [_vm._v(" 開團 "), _c('sort-caret', {
            staticClass: "mx-1",
            attrs: {
              "status": _vm.sortBy === 'start_at' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
            }
          })], 1), _vm._v(" /結團時間 ")])];
        },
        proxy: true
      }], null, true)
    })], 1)]), _c('div', {
      staticClass: "\n              d-flex\n              justify-content-center\n              align-items-center\n              flex-column flex-md-row\n            ",
      staticStyle: {
        "margin-top": "80px"
      }
    }, [_c('b-pagination', {
      staticClass: "separated mb-2 mb-md-0",
      attrs: {
        "total-rows": _vm.total,
        "per-page": _vm.perPage,
        "aria-controls": "groupbuyList"
      },
      on: {
        "change": _vm.handleChangePage
      },
      model: {
        value: _vm.currentPage,
        callback: function callback($$v) {
          _vm.currentPage = $$v;
        },
        expression: "currentPage"
      }
    }), _c('div', {
      staticClass: "ml-2"
    }, [_vm._v(" 每頁顯示數量"), _c('b-form-select', {
      staticClass: "ml-2",
      staticStyle: {
        "width": "70px"
      },
      attrs: {
        "options": _vm.perPageOptions
      },
      on: {
        "change": _vm.handleChangePage
      },
      model: {
        value: _vm.perPage,
        callback: function callback($$v) {
          _vm.perPage = $$v;
        },
        expression: "perPage"
      }
    })], 1)], 1)])], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }